import { useQuery } from "@apollo/client/react";
import { useAccount } from "@/context/account";
import { useFeatureFlags } from "@/context/FeatureFlags";
import { useTranslation } from "react-i18next";
import type { RecentlyViewedItem } from "@/components/app/Navigation/GlobalHeader/RecentlyViewed/types";
import { UiFeatureFlagNames } from "@/gql/graphql";
import { RECENTLY_VIEWED_ITEMS } from "@/hooks/service/recentlyViewedOperations";
import { mapRecentlyViewedItem } from "@/utils/recentlyViewed";

export function useRecentlyViewedItems(options?: { skip?: boolean }): {
  items: RecentlyViewedItem[];
  loading: boolean;
} {
  const { skip = false } = options ?? {};
  const { account, accountRouteId } = useAccount();
  const { t } = useTranslation();
  const { canUseFeatureFlag } = useFeatureFlags();
  const isEnabled = canUseFeatureFlag(UiFeatureFlagNames.RecentlyViewed);

  const { data, loading } = useQuery(RECENTLY_VIEWED_ITEMS, {
    variables: { dealerAccountId: account.id },
    skip: skip || !isEnabled || !account.id,
    fetchPolicy: "network-only",
    context: { skipGlobalError: true },
  });

  const items = (data?.recentlyViewedItems ?? []).map((item) =>
    mapRecentlyViewedItem(accountRouteId, item, t)
  );

  return { items, loading };
}
